export const HIERARCHY_TYPE_PROGRAM = 1;
export const HIERARCHY_TYPE_SUBPROGRAM = 2;
export const HIERARCHY_TYPE_PROJECT = 3;
export const HIERARCHY_TYPE_SAMPLE_EVENT_PHASE = 4;
export const HIERARCHY_TYPE_SAMPLE_EVENT = 5;
